import { Breadcrumbs, Button, Card, CardContent, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from 'axios';
import { Form, Formik, FormikProps } from 'formik';
import { FunctionComponent, useEffect, useRef, useState } from 'react';
import { pdfjs } from 'react-pdf';
import { Link } from 'react-router-dom';
import { PdfViewer } from '../components/atoms/inputs/PdfViewer';
import { AppShell } from '../components/molecules/app-shell/AppShell';
import { useStore } from '../store';
import { ApiResponse } from '../types';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    centerButton: {
        justifyContent: 'center',
        display: 'flex',
    },
}))



type FormikForm = {
    file: any,
    fileName?: string,
}

type TerminalBenefitStatementPageProps = {
}

type PensionerApiData = {
    name: string,
    spouseName: string,
    pensionerAddr: string,
    dobSpouse: string,
    dtRet: string,
    categoryPensioner: string,
    lastPenMonth: string,
    pensionerType: string,
    aadharNo: string,
    panId: string,
    contactNo: string,
    emailId: string,
    bankAccNum: string,
}

type PensionerProfileState = {
    loading: boolean,
    error: string,
    profile: Array<PensionerApiData>
}

export const TerminalBenefitStatementPage: FunctionComponent<TerminalBenefitStatementPageProps> = () => {
    const classes = useStyles()

    const store = useStore()
    const [profileData, setProfile] = useState<PensionerProfileState>({ loading: true, error: '', profile: [] });

    useEffect(() => {
        fetchProfile()
    }, []);

    const fetchProfile = async () => {
        axios.get<ApiResponse<{ profile: PensionerApiData[] }>>(`api/pensioner/profile-details`, {
            headers: {
                'Authorization': `Bearer ${store.auth.jwt}`, 'JWT': `Bearer ${store.auth.jwt}`
            }
        })
            .then(
                ({ data: resp }) => {
                    if (resp.status === "success") {
                        const profile: PensionerApiData[] = resp.data.profile;
                        setProfile({ loading: false, error: '', profile: profile })
                    } else {
                        setProfile({ loading: false, error: resp.message, profile: [] })
                    }
                },
                () => { setProfile({ loading: false, error: "Network Error", profile: [] }) }
            )
    }
    const retirementDate = profileData?.profile[0]?.dtRet;
    const pensionerTypeRaw = profileData?.profile[0]?.pensionerType?.toLowerCase();
    const isSelf = pensionerTypeRaw === "self";
    let retirementYear = 0;
    try {
        if (retirementDate) {
            retirementYear = new Date(retirementDate).getFullYear();
        }
    } catch (e) {
        retirementYear = 0;
    }




    const formikRef = useRef<any>(null);

    useEffect(() => {
        if (formikRef.current) {
            formikRef.current.submitForm(); // Trigger API call
        }
    }, []);

    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Formik
                    innerRef={formikRef}
                    initialValues={{
                        file: null,
                        fileName: '',
                    }}
                    validate={(values) => {
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue, setFieldTouched, setFieldError }) => {
                        setSubmitting(true)
                        setFieldValue('fileName', `emp-terminal-benefits-statement.pdf`)
                        setFieldValue('file', {
                            url: `${process.env.REACT_APP_API_ROOT}api/pensioner/emp-terminal-benefits`,
                            httpHeaders: { 'Authorization': `Bearer ${store.auth.jwt}`, 'JWT': `Bearer ${store.auth.jwt}` },
                        })
                    }}
                >
                    {
                        ({ values, isSubmitting, isValid, setFieldValue, setValues, handleChange, setSubmitting }: FormikProps<FormikForm>) =>
                            <Form>
                                <Grid
                                    item
                                    container
                                    spacing={3}
                                    direction="column"
                                    justify="space-around"
                                    alignItems="stretch"
                                >
                                    <Grid item>
                                        <Card className={classes.controlPaper}>
                                            <CardContent>
                                                <Grid container spacing={3} direction="column" justify="space-around"
                                                    alignItems="stretch">
                                                    <Grid item>
                                                        <Breadcrumbs>
                                                            <Link to="/" className={classes.link}>
                                                                <Typography gutterBottom variant="h5" component="h2">
                                                                    <HomeIcon className={classes.icon} />Home</Typography>
                                                            </Link>
                                                            <Typography gutterBottom variant="h5" component="h2">Terminal Benefit Statement (অবসরকালীন সুবিধা বিবৃতি)</Typography>
                                                        </Breadcrumbs>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>

                                        </Card>
                                    </Grid>
                                    <Grid item>

                                        {/*  Error fetching profile */}
                                        {!profileData.loading && profileData.error && (
                                            <Alert severity="error">
                                                <AlertTitle>Error</AlertTitle>
                                                {profileData.error}
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={fetchProfile}
                                                    style={{ marginTop: '1rem' }}
                                                >
                                                    Retry
                                                </Button>
                                            </Alert>
                                        )}

                                        {/* Not self (family pensioner) */}
                                        {!profileData.loading && !profileData.error && !isSelf && (
                                            <><Alert severity="error" style={{ textAlign: "justify" }}>
                                                <AlertTitle>Error</AlertTitle>
                                                This facility is not available for family pensioners. <br />
                                                <b>(পারিবারিক পেনশনভোগীদের জন্য এই সুবিধাটি উপলব্ধ নয়।)</b>
                                            </Alert>
                                            </>
                                        )}

                                        {/*  Retired before 2016 */}
                                        {!profileData.loading && !profileData.error && isSelf && retirementYear < 2016 && (
                                            <><Alert severity="warning" style={{ textAlign: "justify" }}>
                                                <AlertTitle>Warning</AlertTitle>
                                                Terminal benefits statement is available only for pensioners retired in or after 2016. <br />
                                                <b>(অবসরকালীন সুবিধা বিবৃতি বিবৃতি শুধুমাত্র ২০১৬ সালে বা তার পরে অবসরপ্রাপ্ত পেনশনভোগীদের জন্য উপলব্ধ।)</b>
                                            </Alert>
                                            </>

                                        )}
                                    </Grid>

                                    {
                                        !profileData.loading && !profileData.error && isSelf && retirementYear >= 2016 && (
                                            <>
                                                {
                                                    !!values.file && !!values.fileName &&
                                                    <Grid item>
                                                        <Card>
                                                            <CardContent>
                                                                <PdfViewer
                                                                    downloadFileName={values.fileName}
                                                                    file={values.file}
                                                                    onDocumentLoadSuccess={() => { setSubmitting(false) }}
                                                                    onDocumentLoadError={() => { setSubmitting(false) }}
                                                                    error={
                                                                        <>
                                                                            <Typography
                                                                                variant="h6"
                                                                                component="h6"
                                                                                style={{ textAlign: "center" }}
                                                                                color="secondary"
                                                                            >Unable to load PDF (পিডিএফ লোড করতে অক্ষম)</Typography>
                                                                        </>
                                                                    }
                                                                />
                                                            </CardContent>
                                                        </Card>
                                                    </Grid>
                                                }
                                            </>
                                        )
                                    }

                                    <Grid item className={classes.centerButton}>
                                        <Link to="/" className={classes.link}>
                                            <Button variant='contained' color='primary' size='large'>
                                                Back (পিছনে)
                                            </Button>
                                        </Link>
                                    </Grid>
                                </Grid>
                            </Form>
                    }
                </Formik>
            </Grid>
        </AppShell >
    )
}